import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticateService } from './authenticate.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  constructor(
    public router: Router,
    private authService: AuthenticateService
  ) { }

  getUrlParam(name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  }

  public loginUser() {
    this.router.navigate(["/enetassess"]);
  }

  public logoutAssessor() {
    this.authService.disconnect();
    //console.log("redirecting assessor to - " + window.location.href + "/login?al=1")
    window.location.href = "/login?al=1";
  }

  public logoutAnonymousCandidate() {
    this.authService.disconnect();
    window.location.href = "login?cl=1";
  }

  public goToEnetassess() {
    this.router.navigate(["/enetassess"]);
  }

  public goToFeedback(){
    this.router.navigate(["/feedback"]);
  }

  public logoutUser(enetsecure) {
    this.authService.disconnect();
    if(enetsecure !== null && enetsecure !== undefined && enetsecure !== ""){
      window.location.href = "login?" + enetsecure;
    }    
    else{
      window.location.href = "login";
    }
  }

  public logoutMockUser(mockId) {
    this.authService.disconnect();
    window.location.href = "login?mock=1&mid=" + mockId;
  }

  public alreadyLoggedIn(){
    this.authService.disconnect();
    window.location.href = "/login.aspx?es=1";
  }

  public secureSessionExpired(){
    this.authService.disconnect();
    window.location.href = "/login.aspx?expired=1";
  }

  public logoutUserDelayed() {
    setTimeout( () => { 
      window.location.href = "login"; 
    }, 10000 );
    
  }

  public launchExam() {
    //update schedule candidate status in db
    this.router.navigate(["/loadexam"]);
  }

  public launchExamQuestions() {
    this.router.navigate(["/questions"]);
  }
}
